import { IQuestion } from 'app/interfaces/IQuestion'
import { QuestionPropertiesValidationError } from 'app/custom-errors/QuestionPropertiesValidationError'
import { IMinMaxAnswers } from 'app/interfaces/IMinMaxAnswers'
import { IStatement } from 'app/interfaces/IStatement'
import { ViewerTypeEnum } from 'app/enums/ViewerTypeEnum'

export class QuestionPropertyValidator implements IQuestion {
  key: string
  question: Record<string, string>
  shortLabel: Record<string, string>
  viewerType: ViewerTypeEnum
  shouldSaveInExtProfile: boolean
  isOptional: boolean
  positionLocked: boolean
  limitAnswersAmount: boolean
  randomizeStatements: boolean
  maxAnswers: IMinMaxAnswers
  minAnswers: IMinMaxAnswers
  statements: Record<string, IStatement>
  statementsOrder: string[]
  useUniqueMentionLabel: boolean

  constructor(question: IQuestion) {
    this.key = question.key
    this.question = question.question
    this.shortLabel = question.shortLabel
    this.viewerType = question.viewerType
    this.shouldSaveInExtProfile = question.shouldSaveInExtProfile
    this.isOptional = question.isOptional
    this.positionLocked = question.positionLocked
    this.limitAnswersAmount = question.limitAnswersAmount
    this.randomizeStatements = question.randomizeStatements
    this.maxAnswers = question.maxAnswers
    this.minAnswers = question.minAnswers
    this.statements = question.statements
    this.statementsOrder = question.statementsOrder
    this.useUniqueMentionLabel = question.useUniqueMentionLabel
  }

  validate() {

    const requiredProperties = Object.getOwnPropertyNames(this)
    const missingProperties: string[] = []
    for (const idx in requiredProperties) {
      if (this[requiredProperties[idx]] === undefined || this[requiredProperties[idx]] === null) {
        missingProperties.push(requiredProperties[idx])
      }
    }

    if (missingProperties.length) {
      throw new QuestionPropertiesValidationError(missingProperties, this)
    }

  }
}
